const getMultipleShippingLabelsPdf = async (labels, token) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ labels }),
  };

  const res = await fetch(
    process.env.REACT_APP_ASSET_URL +
      `/bol/orders/get-multiple-shipping-labels-pdf`,
    requestOptions
  );

  const contentType = res.headers.get("content-type") || "";

  if (!res.ok) {
    // ❌ Foutpad → probeer JSON te lezen, anders text
    if (contentType.includes("application/json")) {
      const data = await res.json().catch(() => ({}));
      console.error("Backend error (JSON):", data);
      throw new Error(
        data?.message ||
          `Bulk verzendzegels ophalen mislukt (HTTP ${res.status})`
      );
    } else {
      const text = await res.text().catch(() => "");
      console.error("Backend error (TEXT):", text);
      throw new Error(
        text || `Bulk verzendzegels ophalen mislukt (HTTP ${res.status})`
      );
    }
  }

  // ✅ Succes → PDF blob teruggeven
  if (contentType.includes("application/pdf")) {
    return await res.blob();
  }

  // Fallback: alsnog als blob proberen, maar even waarschuwen
  console.warn("Onverwachte content-type:", contentType);
  return await res.blob();
};

export default getMultipleShippingLabelsPdf;
